import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AllUserPortfoliosGQL } from "../data-services/graphql";

@Injectable({
    providedIn: 'root'
})
export class DimensionPortfolioDataService {

    constructor(
        private allUserPortfoliosGQL: AllUserPortfoliosGQL
    ) { }

    public getUserPortfolios(): Observable<any> {
        return this.allUserPortfoliosGQL.fetch({
        variables: {},
        fetchPolicy: 'no-cache'}).pipe(map(data => data.data.user.user_portfolios));
    }
}
